var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 73,
    viewBox: "0 0 53 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.5539 70.8032V9.20244C43.5539 7.71307 42.3465 6.50586 40.8572 6.50586H3.19658C1.70721 6.50586 0.5 7.71321 0.5 9.20244V70.8032C0.5 72.2925 1.70735 73.4998 3.19658 73.4998H40.8573C42.3465 73.4998 43.5539 72.2924 43.5539 70.8032Z",
    fill: "#A76A01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.6987 6.50586H40.6736C42.163 6.50586 43.3704 7.71321 43.3704 9.20244V70.8032C43.3704 72.2925 42.163 73.4998 40.6736 73.4998H49.6987C51.1881 73.4998 52.3954 72.2924 52.3954 70.8032V9.20258C52.3954 7.71321 51.1881 6.50586 49.6987 6.50586Z",
    fill: "#A76A01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.90753 68.129V11.8779C4.90753 11.3455 5.33911 10.9141 5.87136 10.9141H47.024C47.5564 10.9141 47.9878 11.3456 47.9878 11.8779V68.129C47.9878 68.6613 47.5562 69.0928 47.024 69.0928H5.87136C5.33897 69.0928 4.90753 68.6613 4.90753 68.129Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.024 10.9141H37.9989C38.5313 10.9141 38.9627 11.3456 38.9627 11.8779V68.129C38.9627 68.6613 38.5311 69.0928 37.9989 69.0928H47.024C47.5563 69.0928 47.9878 68.6612 47.9878 68.129V11.8779C47.9878 11.3456 47.5563 10.9141 47.024 10.9141Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.1763 3.856V2.43635C32.1763 1.36702 31.3094 0.5 30.24 0.5H22.6552C21.5858 0.5 20.7189 1.36702 20.7189 2.43635V3.856C20.7189 4.29329 20.3643 4.64788 19.927 4.64788H16.7703C15.7202 4.64788 14.8689 5.49922 14.8689 6.5493V10.9136H38.0263V6.5493C38.0263 5.49922 37.175 4.64788 36.1249 4.64788H32.9682C32.5309 4.64788 32.1763 4.29329 32.1763 3.856Z",
    fill: "#C2D0DA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.5141 26.5619V18.0731C10.5141 17.1326 11.2766 16.3701 12.2171 16.3701H20.7059C21.6463 16.3701 22.4088 17.1326 22.4088 18.0731V26.5619C22.4088 27.5023 21.6463 28.2648 20.7059 28.2648H12.2171C11.2765 28.2648 10.5141 27.5023 10.5141 26.5619Z",
    fill: "#66B49D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.5141 44.2474V35.7586C10.5141 34.8182 11.2766 34.0557 12.2171 34.0557H20.7059C21.6463 34.0557 22.4088 34.8182 22.4088 35.7586V44.2474C22.4088 45.1879 21.6463 45.9504 20.7059 45.9504H12.2171C11.2765 45.9504 10.5141 45.1879 10.5141 44.2474Z",
    fill: "#66B49D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.5141 61.933V53.4442C10.5141 52.5037 11.2766 51.7412 12.2171 51.7412H20.7059C21.6463 51.7412 22.4088 52.5037 22.4088 53.4442V61.933C22.4088 62.8734 21.6463 63.6359 20.7059 63.6359H12.2171C11.2765 63.6359 10.5141 62.8736 10.5141 61.933Z",
    fill: "#66B49D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.7429 25.3576C15.7416 25.3576 15.7404 25.3576 15.7392 25.3576C15.2528 25.3565 14.7916 25.121 14.5051 24.7279L13.2188 22.9613C12.8606 22.4694 12.969 21.7804 13.4609 21.4222C13.9528 21.0642 14.6419 21.1726 14.9999 21.6643L15.7457 22.6887L17.9265 19.726C18.2872 19.2359 18.9767 19.1313 19.4666 19.4918C19.9566 19.8524 20.0614 20.5421 19.7007 21.0321L16.9757 24.7342C16.6884 25.1247 16.2276 25.3576 15.7429 25.3576Z",
    fill: "#F6F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.7427 43.4279C15.7413 43.4279 15.74 43.4279 15.7387 43.4279C15.2524 43.4266 14.7912 43.1912 14.5049 42.7979L13.2188 41.0316C12.8606 40.5397 12.969 39.8506 13.4609 39.4925C13.9528 39.1345 14.6419 39.2428 14.9999 39.7346L15.7457 40.759L17.9265 37.7962C18.2872 37.3063 18.9767 37.2015 19.4666 37.5621C19.9566 37.9227 20.0614 38.6123 19.7007 39.1024L16.9757 42.8044C16.6884 43.1952 16.2276 43.4279 15.7427 43.4279Z",
    fill: "#F6F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.7427 60.7287C15.7415 60.7287 15.7402 60.7287 15.739 60.7286C15.2528 60.7274 14.7915 60.492 14.5052 60.0991L13.2188 58.3322C12.8607 57.8404 12.9692 57.1514 13.4611 56.7933C13.9532 56.4351 14.642 56.5437 15 57.0355L15.7457 58.0598L17.9266 55.097C18.2873 54.6071 18.9768 54.5023 19.4667 54.8629C19.9568 55.2235 20.0616 55.9131 19.7008 56.4032L16.9759 60.1052C16.6883 60.4957 16.2276 60.7287 15.7427 60.7287Z",
    fill: "#F6F9F9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M41.5126 21.1172H27.8942C27.2858 21.1172 26.7927 20.624 26.7927 20.0156C26.7927 19.4072 27.2858 18.9141 27.8942 18.9141H41.5126C42.1209 18.9141 42.6141 19.4072 42.6141 20.0156C42.6141 20.624 42.1209 21.1172 41.5126 21.1172Z",
    fill: "#DDEAFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.7035 25.7207H27.8944C27.286 25.7207 26.7928 25.2275 26.7928 24.6191C26.7928 24.0108 27.286 23.5176 27.8944 23.5176H34.7035C35.3119 23.5176 35.8051 24.0108 35.8051 24.6191C35.8051 25.2275 35.3119 25.7207 34.7035 25.7207Z",
    fill: "#DDEAFB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M37.0317 38.8037H27.8944C27.286 38.8037 26.7928 38.3105 26.7928 37.7021C26.7928 37.0938 27.286 36.6006 27.8944 36.6006H37.0317C37.64 36.6006 38.1332 37.0938 38.1332 37.7021C38.1332 38.3105 37.64 38.8037 37.0317 38.8037Z",
    fill: "#DDEAFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.7035 43.4072H27.8944C27.286 43.4072 26.7928 42.914 26.7928 42.3057C26.7928 41.6973 27.286 41.2041 27.8944 41.2041H34.7035C35.3119 41.2041 35.8051 41.6973 35.8051 42.3057C35.8051 42.914 35.3119 43.4072 34.7035 43.4072Z",
    fill: "#DDEAFB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentReportIcon);
export default __webpack_public_path__ + "static/media/AssessmentReportIcon.26b573527e887e4f12a6dca9b5ade52b.svg";
export { ForwardRef as ReactComponent };